import type { BoxTabProps } from './BoxTab';
import type { BoxTabsProps } from './BoxTabs';
import type { LineTabComponentProps, LineTabProps } from './LineTab';
import type { LineTabsComponentProps, LineTabsProps } from './LineTabs';

type DistributiveOmit<T, Keys extends PropertyKey> = T extends unknown ? Omit<T, Keys> : never;

export type OldBoxTabProps = DistributiveOmit<BoxTabProps, 'onTabSelect'> & {
  /** @deprecated onTabSelect를 대신 사용해주세요. */
  onClick?: BoxTabProps['onTabSelect'];
};

export function convertOldBoxTabProps(props: OldBoxTabProps): BoxTabProps {
  const { onClick, ...restProps } = props;

  return {
    ...restProps,
    onTabSelect: onClick,
  } as BoxTabProps;
}

export type OldBoxTabsProps = BoxTabsProps & {
  /** @deprecated onAdd 또는 renderAddAction을 지정하면 추가 버튼이 표시됩니다. */
  showAddButton?: boolean;
};

export function convertOldBoxTabsProps(props: OldBoxTabsProps): BoxTabsProps {
  const { showAddButton: _showAddButton, ...restProps } = props;

  return restProps;
}

export interface OldLineTabProps
  extends Omit<LineTabProps, 'hasNewBadge' | 'hasBetaBadge' | 'hasNotification' | 'count' | 'onTabSelect'> {
  /** @deprecated hasNewBadge를 대신 사용해주세요. */
  is_new?: boolean;
  /** @deprecated hasBetaBadge를 대신 사용해주세요. */
  is_beta?: boolean;
  /** @deprecated hasNotification을 대신 사용해주세요. */
  has_notification?: boolean;
  /** @deprecated count를 대신 사용해주세요. */
  number_label?: number;
  /** @deprecated onTabSelect를 대신 사용해주세요. */
  onClick?: LineTabProps['onTabSelect'];
}

export type OldLineTabComponentProps = React.PropsWithChildren<OldLineTabProps>;

export function convertOldLineTabProps(props: OldLineTabComponentProps): LineTabComponentProps {
  const { is_new, is_beta, has_notification, number_label, onClick, ...restProps } = props;

  return {
    ...restProps,
    hasNewBadge: is_new,
    hasBetaBadge: is_beta,
    hasNotification: has_notification,
    count: number_label,
    onTabSelect: onClick,
  };
}

export interface OldLineTabsProps extends LineTabsProps {
  /** @deprecated paddingHorizontal을 대신 사용해주세요. */
  horizontalPadding?: boolean;
}

export type OldLineTabsComponentProps = React.PropsWithChildren<OldLineTabsProps>;

export function convertOldLineTabsProps(props: OldLineTabsComponentProps): LineTabsComponentProps {
  const { horizontalPadding, paddingHorizontal, ...restProps } = props;

  return {
    ...restProps,
    paddingHorizontal: paddingHorizontal ?? horizontalPadding,
  };
}
